import { createSelector } from 'reselect';
import _intersection from 'lodash/intersection';
import { Api, Flags } from 'enums';
import appSelector, { countrySelector } from './appSelector';
import routingSelector from './routingSelector';

const { Page: { EVENT_QUERY_KEYS } } = Api;

const pageSelector = ({ page = {} }) => page;

const intlSelector = (_, { messages, intl }) => ({ messages, intl });

export default createSelector(pageSelector, (page) => page);

function meta(id, name, messages, formatMessage) {
    const opts = { name };
    const pageId = messages[`meta.title.${id}`] ? id : 'home';
    const title = formatMessage(messages[`meta.title.${pageId}`], opts);
    const description = formatMessage(messages[`meta.description.${pageId}`], opts);
    const keywords = formatMessage(messages['meta.keywords']);

    return {
        title,
        description,
        keywords
    };
}

export const metaSelector = createSelector(
    appSelector,
    routingSelector,
    pageSelector,
    intlSelector,
    (
        { location = {} },
        { locationBeforeTransitions = {} },
        { id = 'home', name, hero },
        { messages, intl: { formatMessage } = {} } = {}
    ) => {
        const { host, protocol, path, baseUrl, query: origQuery } = location;
        const { basename = baseUrl, pathname = path, query = origQuery } = locationBeforeTransitions || {};
        let imageUrl = 'https://secure.espncdn.com/watchespn/images/watch-promotional.jpg';
        let noIndex = false;

        const heroImageUrl = hero && hero.imageHref;
        const hasEventIdInUrl = _intersection(Object.keys(query), EVENT_QUERY_KEYS).length > 0;
        // only set the hero image as open graph image when the URL specifies the particular event.
        if (heroImageUrl && hasEventIdInUrl) {
            imageUrl = heroImageUrl;
            if (hero.status === 'over') {
                noIndex = true;
            }
        }

        const metaTags = meta(id, (hero && hero.name) || name, messages, formatMessage);

        return {
            ...metaTags,
            canonicalUrl: `${protocol}://${host}${basename}${pathname}`,
            imageUrl,
            noIndex
        };
    }
);

export const editionSelector = createSelector(pageSelector, ({ edition = {} }) => edition);

export const brandingSelector = createSelector(editionSelector,
    ({ branding = {
        name: 'WatchESPN',
        logoUrl: 'http://a.espncdn.com/redesign/assets/img/logos/logo-espn-watch-black@2x.png' } }) => branding);

export const showSearchByCountrySelector = createSelector(countrySelector, (country = 'us') => (country === 'us'));

export const hideNavSelector = createSelector(appSelector,
    ({ location: { query = {} } = {} }) => ((query && query[Flags.HIDENAV] === true) || false));



// WEBPACK FOOTER //
// ./app/selectors/pageSelector.js